import request from '@/utils/request'


// 查询运输方式列表
export function listTransportation(query) {
  return request({
    url: '/user/transportation/list',
    method: 'get',
    params: query
  })
}

// 查询运输方式分页
export function pageTransportation(query) {
  return request({
    url: '/user/transportation/page',
    method: 'get',
    params: query
  })
}

// 查询运输方式详细
export function getTransportation(data) {
  return request({
    url: '/user/transportation/detail',
    method: 'get',
    params: data
  })
}

// 新增运输方式
export function addTransportation(data) {
  return request({
    url: '/user/transportation/add',
    method: 'post',
    data: data
  })
}

// 修改运输方式
export function updateTransportation(data) {
  return request({
    url: '/user/transportation/edit',
    method: 'post',
    data: data
  })
}

// 删除运输方式
export function delTransportation(data) {
  return request({
    url: '/user/transportation/delete',
    method: 'post',
    data: data
  })
}
